import { Button, Flex, RootProvider, StatusWidget } from '@revolut-internal/ui-kit'
import { Link } from 'react-router-dom'

import { getRootRoute } from 'lib/router'

import { getInitialThemeMode } from './getInitialThemeMode'

export const ErrorFallback = () => (
  <RootProvider mode={getInitialThemeMode()}>
    <Flex minHeight="100vh" alignItems="center" justifyContent="center">
      <StatusWidget>
        <StatusWidget.Image
          image={{
            default: 'https://assets.revolut.com/assets/3d-images-v2/3D018.png',
            '2x': 'https://assets.revolut.com/assets/3d-images-v2/3D018@2x.png',
            '3x': 'https://assets.revolut.com/assets/3d-images-v2/3D018@3x.png',
          }}
        />
        <StatusWidget.Title>Something went wrong</StatusWidget.Title>
        <StatusWidget.Actions>
          <Button elevated use={Link} to={getRootRoute()}>
            Home page
          </Button>
        </StatusWidget.Actions>
      </StatusWidget>
    </Flex>
  </RootProvider>
)
